import { PHONE_NUMBER_REGEX } from "static/constants";
import * as Yup from "yup";

export const enrollFormValidationSchema = Yup.object().shape({
  model_name: Yup.string().required("Model name is required"),
  doi: Yup.date()
    .nullable()
    .typeError("Please enter a valid date in MM/DD/YYYY format")
    .required("Date of Implant is required")
    .max(new Date(), "Date cannot be in the future"),
  phone: Yup.string().matches(
    PHONE_NUMBER_REGEX,
    "Invalid phone number format"
  ),
  street: Yup.string(),
  city: Yup.string(),
  state: Yup.string(),
  zip: Yup.string(),
  next_send: Yup.string(),
  first_call: Yup.string(),
  second_call: Yup.string(),
  third_call: Yup.string(),
  letter: Yup.string(),
});
